/**
 * CSVエクスポート用ヘルパー（複数画面で共用）
 *
 * escapeFormulas: Excel/Sheets 等の formula injection 対策 (先頭 =+-@tab/CR にシングルクォート前置)。
 *   デフォルト true (人間がダウンロードして Excel 等で開く「エクスポート」用途)。
 *   手入力画面のように「ブラウザが生成した CSV をそのまま自前パーサ (csv-parse) へ即アップロードする」
 *   往復専用の用途では Excel を一切介さないため、この前置がむしろ負の数値や自由記述欄を破損させる
 *   (例: "-5000" → "'-5000" になり z.coerce.number() が NaN 判定、item_name に "'" が永続保存される)。
 *   その場合は escapeFormulas=false を指定すること。
 */
export const csvEscape = (v: unknown, escapeFormulas = true): string => {
  if (v === null || v === undefined) return '';
  let s = String(v);
  if (escapeFormulas && s.length > 0 && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[,\r\n"]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** ヘッダー配列 + 行データから CSV 文字列 (BOM付きUTF-8, CRLF) を組み立てる */
export const buildCsvText = (
  headers: string[],
  rows: Array<Record<string, unknown>>,
  escapeFormulas = true,
): string => {
  // QA/Testレビュー LOW反映 (Lite版CSV雛形DL、2026-08-06): ヘッダー自体が固定の英数字ではなく
  // テナントのマスタ名 (勘定科目/仕入先名、横持ちレイアウトの列見出しに使われる) 等の動的な値になる
  // 呼び出し元があるため、値と同様にエスケープする (カンマ/改行を含む名前でのCSV構造破壊、
  // および先頭"="等のformula injectionを防ぐ)。固定の英数字ヘッダーには影響しない。
  const lines = [headers.map((h) => csvEscape(h, escapeFormulas)).join(',')];
  for (const r of rows) {
    lines.push(headers.map((h) => csvEscape(r[h], escapeFormulas)).join(','));
  }
  return '﻿' + lines.join('\r\n') + '\r\n';
};

export const downloadAsCsv = (
  filename: string,
  headers: string[],
  rows: Array<Record<string, unknown>>,
): void => {
  const content = buildCsvText(headers, rows);
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
